import { render, staticRenderFns } from "./VerticalNavMenuItem.vue?vue&type=template&id=3e86146c&scoped=true"
import script from "./VerticalNavMenuItem.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuItem.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuItem.vue?vue&type=style&index=0&id=3e86146c&prod&lang=scss&scoped=true"
import style1 from "./VerticalNavMenuItem.vue?vue&type=style&index=1&id=3e86146c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e86146c",
  null
  
)

export default component.exports